var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "13 13 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "wallet_svg__a_CC5TOSEI",
    d: "M0 0h44v44H0Z"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "translate(13 13)",
    d: "M18 15v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v1H9a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h9Zm-9-2h10V5H9v8Zm4-2.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgWallet;